import {
  SPECIFIED_DATE_RANGE_JSON_DATA,
  COMPARISON_DATE_JSON_DATA,
  FORMAT_RESULT_JSON_DATA,
  EXPORT_REPORT_TYPE_DATA,
  MEASURES_SELECTION_MODAL_SHOW,
  CALCULATE_COMPARISON,
  RETAIL_MEASURES_MODAL_SHOW,
  RETAIL_METRICS_MEASURES_DATA,
  DASHBOARD_SEARCH_DATA,
  JSON_TO_EXCEL_DATA
} from "../../constants/ActionTypes";
import moment from "moment";
import { isEmptyObject } from ".";

//#region **********Specified Date Range component************

export function loadSpecifiedDateRangeData(loadValue) {
  return (dispatch) => {
    dispatch({ type: SPECIFIED_DATE_RANGE_JSON_DATA, payload: loadValue });
  };
}
export function loadComparisonDateData(loadValue) {
  return (dispatch) => {
    dispatch({ type: COMPARISON_DATE_JSON_DATA, payload: loadValue });
  };
}
export function loadFormatResultData(loadValue) {
  return (dispatch) => {
    dispatch({ type: FORMAT_RESULT_JSON_DATA, payload: loadValue });
  };
}
export function loadExportReportTypeData(loadValue) {
  return (dispatch) => {
    dispatch({ type: EXPORT_REPORT_TYPE_DATA, payload: loadValue });
  };
}
export function loadMeasureSelectionModalShow(loadValue) {
  return (dispatch) => {
    dispatch({ type: MEASURES_SELECTION_MODAL_SHOW, payload: loadValue });
  };
}

export function loadCalculateComparison(loadValue) {
  return (dispatch) => {
    dispatch({ type: CALCULATE_COMPARISON, payload: loadValue });
  };
}
export function loadRetailMeasuresModalShow(loadValue) {
  return (dispatch) => {
    dispatch({ type: RETAIL_MEASURES_MODAL_SHOW, payload: loadValue });
  };
}


export function loadRetailMetricsMeasureData(loadValue) {
  return (dispatch) => {
    dispatch({ type: RETAIL_METRICS_MEASURES_DATA, payload: loadValue });
  };
}
export function loadDashboardSearchData(loadValue) {
  return (dispatch) => {
    dispatch({ type: DASHBOARD_SEARCH_DATA, payload: loadValue });
  };
}
export function loadJsonToExcelData(loadValue) {
  return (dispatch) => {
    dispatch({ type: JSON_TO_EXCEL_DATA, payload: loadValue });
  };
}




export function calculateComparisonDate(data, dispatch) {
  let fromDate = data.IsSpecificPeriod ?  data.SpecificPeriodDates.FromDate ? data.SpecificPeriodDates.FromDate : '' : data.SpecificDatesRange.FromDate ? data.SpecificDatesRange.FromDate : '' ;
  let toDate = data.IsSpecificPeriod ? data.SpecificPeriodDates.ToDate ? data.SpecificPeriodDates.ToDate : '' :data.SpecificDatesRange.ToDate ? data.SpecificDatesRange.ToDate : ''  ;
  if (moment.isMoment(fromDate) || moment.isMoment(toDate)) {
    if (moment.isMoment(fromDate)) {
      fromDate = moment(fromDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    }
    if (moment.isMoment(toDate)) {
      toDate = moment(toDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    }
  }
  if (fromDate != '' && toDate != '') {
    fromDate = moment(fromDate, 'YYYY-MM-DDTHH:mm:ss');
    toDate = moment(toDate, 'YYYY-MM-DDTHH:mm:ss');
    const subFrom = fromDate.subtract(1, 'years').format("YYYY-MM-DDTHH:mm:ss");
    const subTo = toDate.subtract(1, 'years').format("YYYY-MM-DDTHH:mm:ss");
    const periodFrom = fromDate.add(1, 'days').format("YYYY-MM-DDTHH:mm:ss");
    const periodTo = toDate.add(1, 'days').format("YYYY-MM-DDTHH:mm:ss");
    const displayYearly = `${subFrom} to ${subTo}`;
    const displayPeriod = `${periodFrom} to ${periodTo}`;
    const body = {
      subFrom: subFrom,
      subTo: subTo,
      periodFrom: periodFrom,
      periodTo: periodTo,
      displayYearly: displayYearly,
      displayPeriod: displayPeriod,
    };
    dispatch(loadCalculateComparison(body));
  }
}